import React from 'react';
import { TipsMapType } from '../index';
import { documentCh, documentEh } from './utils';

export const gameStoreGoogleLifetimeText: TipsMapType = {
  en: 'The Lifetime Accumulative Reviews of Google Play does not distinguish between countries. The table only shows the number of reviews under the corresponding edition of countries.',
  zh: '累积评论数未区分国家，表格仅展示国家对应版本下的评论数。',
};

export const gameStoreGoogleLifetimeTipsText: TipsMapType = {
  en: (
    <>
      Global：The cumulative rating and total reviews for all countries
      <br />
      Country：The cumulative rating and total reviews for the country.
    </>
  ),
  zh: (
    <>
      全球：所有国家的历史累计评分以及所有国家的历史累计评论总数。
      <br />
      国家：该国家的历史累计评分以及历史累计评论总数。
    </>
  ),
};

export const gameStoresSelectedGoogleText: TipsMapType = {
  en: (
    <>
      The countries displayed in Google Play reviews are obtained by crawling
      through the Google Play scores for each language and then mapping the
      language to the country.
      <br />
      <br />
      {documentEh}
    </>
  ),
  zh: (
    <>
      Google Play 评论中显示的国家，是通过爬取 Google Play
      各语种评分后，再通过语种映射到国家而获得。
      <br />
      <br />
      {documentCh}
    </>
  ),
};

export const gameStoreReviewsTips: TipsMapType = {
  en: 'The Lifetime Accumulative Ratings of Google Play is the sum of the number of reviews under each Edition.',
  zh: 'Google Play Lifetime Ratings 累积评论数为各 Edition 下的评论数之和。',
};

export const gameStoreAlertCountriesTips: TipsMapType = {
  en: `The following table will screen out the countries/regions where score is below the threshold
  (Lifetime Accum. Rating below 4.0, Selected AVG. Rating below 3.5), and use red background to mark
  the cells on the corresponding User Scores.`,
  zh: ' 下方表格将筛选出表格中分数低于阈值（历史累积评分低于4.0，新增评论评分低于3.5）的告警国家/地区，并在对应告警的商店评分上进行单元格标红处理。',
};

export const gameStoreAlertLanguageTips: TipsMapType = {
  en: `The following table will screen out the language where score is below the threshold (Steam Lifetime Recommended% below 85%,Steam Recent Recommended% below 90%,Steam Selected Recommended% below 90%,Xbox Accumulated AVG. Rating below 4.0,Xbox Selected AVG. Rating below 3.5), and use red background to mark the cells on the corresponding User Scores.`,
  zh: '下表将筛选出分数低于阈值的语言（Steam累计推荐百分比低于85%，Steam最近推荐百分比低于90%，Steam所选时段推荐百分比低于90%，Xbox历史累积评分低于4.0，Xbox新增评论评分低于3.5)的语种类型，并在相应用户评分上进行单元格标红处理',
};

export const gameStoreCollectedCountriesTips: TipsMapType = {
  en: (
    <>
      Set the countries you want to focus on, and they will be displayed in the
      table by default, and this change takes effect for you only.
      <br />
      After modifying the options, click on the blank area to take effect.
    </>
  ),
  zh: (
    <>
      设置需关注的国家，这些国家将默认展示在下方表格，修改仅针对本用户生效。
      <br />
      修改选项后，点击空白处即生效。
    </>
  ),
};

export const gameStoreAppleStoreTableHeaderTips: TipsMapType = {
  en: "The Apple Store reviews are delayed by 2 days, and the earliest selected AVG. Rating can only display statistics based on the day before yesterday's reviews （The Lifetime Accum.Rating can display today's real-time value）",
  zh: '苹果商店评论滞后2天，所选时段平均评分最早仅能展示基于前天评论的统计结果（历史累积评分可显示今日实时数值）',
};

export const steamLifetimeTableTips: TipsMapType = {
  en: 'The Lifetime Recommended% of each language in the Steam source is calculated from all historical data in the database.',
  zh: 'Steam源的各个语言累计推荐百分比是把数据库中的所有历史数据进行计算得来的。',
};

export const steamRecentTableTips: TipsMapType = {
  en: 'The Recent Recommended% for each language in the Steam source is calculated by calculating the historical data of the last thirty days.',
  zh: 'Steam源的各个语言最近推荐百分比是通过计算最近三十天的历史数据得来的。',
};

export const xboxLifetimeTableTips: TipsMapType = {
  en: 'The cumulative rating of each language of the Xbox source is obtained by calculating all historical data in the database.',
  zh: 'Xbox源的各个语言累计评分是通过计算数据库中的所有历史数据得来的。',
};

export const steamPositiveHoverTips: TipsMapType = {
  en: 'Recommended from steam.',
  zh: 'steam平台推荐点赞。',
};

export const steamNegativeHoverTips: TipsMapType = {
  en: 'Not recommended from steam.',
  zh: 'steam平台不推荐。',
};

export const mobileGameStoreRating: TipsMapType = {
  en: 'Not Recommended (The rating numbers on Google Play platform is calculated based on ratios, not real data)',
  zh: '不推荐（因为Google Play平台的评分数是基于比例计算的，非真实数据）',
};
